<template>
  <nav class="text-white sm:flex sm:items-center sm:px-4 sm:justify-between" :class="{ hidden: !isOpen, block: isOpen }">
    <div class="sm:flex sm:items-center">
      <div class="px-2 pt-2 pb-5 sm:flex sm:border-b-0 sm:py-0 sm:px-0">
        <router-link v-for="route in routes" :key="route.path" :to="{name: route.name}" class="block px-3 py-1 hover:text-blue-500 sm:text-sm sm:px-2" active-class="border-b-2 border-blue-500 font-semibold">
          {{ route.alias }}
        </router-link>

      </div>
      <div class="relative px-5 py-5 sm:py-0 sm:ml-4 sm:px-0">
        <div class="flex items-center sm:hidden">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 object-cover rounded-full border-2 fill-current text-white" fill="none" viewBox="0 0 20 20">
            <path d="M5 5a5 5 0 0 1 10 0v2A5 5 0 0 1 5 7V5zM0 16.68A19.9 19.9 0 0 1 10 14c3.64 0 7.06.97 10 2.68V20H0v-3.32z" />
          </svg>

          <span v-if="oidcUser" class="ml-4 font-semibold text-gray-200 sm:hidden">{{ oidcUser.name }}</span>
        </div>
        <div class="mt-5 sm:hidden">
          <router-link class="mt-3 block text-gray-400 hover:text-white" :to="{
                name: 'myaccount'
              }">
            Mitt Konto
          </router-link>

          <a href="#" class="mt-3 block text-gray-400 hover:text-white" @click="signOutOidc()">Logga ut</a>
        </div>
        <Dropdown class="hidden sm:block">
          <template #trigger="{ hasFocus, isOpen }">
            <span class="block h-8 w-8 overflow-hidden rounded-full border-2" :class="[
                  hasFocus || isOpen ? 'border-white' : 'border-gray-600'
                ]">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-full w-full fill-current text-white" fill="none" viewBox="0 0 20 20">
                <path d="M5 5a5 5 0 0 1 10 0v2A5 5 0 0 1 5 7V5zM0 16.68A19.9 19.9 0 0 1 10 14c3.64 0 7.06.97 10 2.68V20H0v-3.32z" />
              </svg>
            </span>
          </template>
          <template #dropdown>
            <div class="mt-3 bg-white xl:border rounded-lg w-48 py-2 shadow-xl">
              <router-link class="block hover:text-white text-gray-800 mt-0 px-2 py-1 hover:bg-blue-500" :to="{
                    name: 'myaccount'
                  }">
                Mitt Konto
              </router-link>
              <a href="#" class="block hover:text-white text-gray-800 mt-0 px-2 py-1 hover:bg-blue-500" @click="signOutOidc()">Logga ut</a>
            </div>
          </template>
        </Dropdown>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Dropdown from "@/components/Dropdown";
import { navFilter } from "@/utils/nav-filter";

export default {
  name: "sitenavigation",
  components: { Dropdown },
  props: { isOpen: Boolean },
  data() {
    return {
      routes: []
    };
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"])
  },
  methods: {
    ...mapActions("oidcStore", ["authenticateOidcSilent", "signOutOidc"]),
    toggle() {
      this.isOpen = !this.isOpen;
    }
  },
  mounted() {
    this.routes = navFilter(
      this.$router.options.routes[0].children,
      this.oidcUser
    );
  }
};
</script>
